import React from "react";
import { range } from "lodash";
import "./DnaAnimation.scss";

const numOfDnaDots = 20;
const DnaAnimation = () => (
  <div className="dna-animation">
    <div className="dna-animation__dots">
      {range(0, numOfDnaDots).map(i => (
        <span key={i} />
      ))}
    </div>
  </div>
);

export default DnaAnimation;
